define('views/modules/calendar/animated-session/custom-exercises-manager/custom-exercises-manager-content',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/i18n',
    // collections
    'collections/calendar/session/custom-animations',
    'collections/calendar/session/tags',
    // Views
    'views/parts/form/textbox',
    'views/parts/menu/menu-action',
    'views/modules/calendar/animated-session/animation/lists/animation-list',
    'views/modules/calendar/animated-session/custom-exercises-manager/edit/custom-exercise-edit-panel',
    // Templates Blocks
    'text!templates/modules/calendar/animated-session/custom-exercises-manager/custom-exercises-manager-content.html'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    i18n,
    // collections
    CCustomAnimations,
    CTags,
    // Views
    VTextBox,
    VMenuAction,
    VAnimationList,
    VCustomExerciseEditPanel,
    // Template
    TCustomExercisesManagerContent
) {

    var VCustomExercisesManagerContent = Backbone.View.extend({
        template: TCustomExercisesManagerContent,

        regions: {
            root: "#custom-exercises-manager-content",
            menu: ".menu-actions",
            search: ".search-placeholder",
            add: {
                elem: "#add-custom-exercise",
                form: "#add-custom-exercise-form",
            },
            list: "#custom-exercises-list"
        },

        initialize: function(opt) {
            this.options = opt || {};

            _.extend(this, {
                tags: new CTags(),
                collection: new CCustomAnimations(),
                group: opt.group,
                panel: {}
            });

            var view = this.view = {
                list: new VAnimationList({
                    collection: this.collection,
                    custom: true,
                    manager: true,
                    sortable: false,
                    group: this.group,
                    button: {
                        label: 'calendar:Show more custom exercises'
                    },
                    bottom: true
                }),
                search: new VTextBox({ label: 'Search-by-keyword', attribute: 'query', autofocus: true }),
                menu: new VMenuAction({
                    context: this,
                    onClick: this.onActionClick,
                    radio: false,
                    collection: new Backbone.Collection([{
                        title: i18n.t('messages:tooltip-add-custom-exercise'),
                        itemClass: 'big-action',
                        content: '<strong>+</strong>',
                        skipTranslation: 'true',
                        callback: this.onAddCustomExerciseAction
                    }
                    // , { route: '#',
                    //     title: i18n.t('messages:tooltip-search'),
                    //     icon: 'sl-icon-magnifier',
                    //     toggle: true,
                    //     callback: this.onSearchAction }
                  ]),

                    tooltip: { container: this.regions.root, }
                }),
            };

            this.listenTo(this.collection, { "animation:click": this.onExerciseClick });
            this.listenTo(this.collection, { "change": this.onCollectionChange });
            this.listenTo(view.search, 'submit', this.onQuerySubmit);
            this.listenTo(view.search, 'change', this.onChange);
            this.listenTo(this.view.list.collection, 'sync', this.onCollectionChange);
        },

        render: function() {
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext()));

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.assign(view.menu, zone.$menu)
                .assign(view.search, zone.$search)
                .assign(view.list, zone.$list);

            this.collection.getFirstPage();
            view.search.setValue("");

            return this;
        },

        lazyInit: function() {
            var view = this.panel.edit;
            if (!view) {
                view = this.panel.edit = new VCustomExerciseEditPanel({ group: this.group });
                this.listenTo(view, 'form:success', this.onExerciseUpdate);
            }
            return view;
        },

        /////////////
        // actions //
        /////////////
        onActionClick: function(e) {
            e.preventDefault();
        },

        onSearchAction: function(e, itemModel) {
            if (itemModel.get('active')) {
                this.zone.$search.fadeIn(300);
            } else {
                this.onQuerySubmit(null, "");
                this.view.search.model.set("query", "");
                this.zone.$search.fadeOut(300);
            }
        },

        onChange: function(content) {
          if (content === "") {
            this.onQuerySubmit(null, content);
          }
        },

        onQuerySubmit: function(model, value) {
            if (this.currentQuery === value) return;
            var view = this.view.list;

            view.setQuery(value);
            this.currentQuery = value;
        },

        onAddCustomExerciseAction: function(e, itemModel) {
            var panel = this.lazyInit();
            panel.resetModel();
            this.trigger('panel:stack', panel);
        },

        ////////////
        // events //
        ////////////
        onCollectionChange: function() {
          // var count = this.collection.models.length;
          // var label = i18n.t("Search");
          // if (!_.isEmpty(this.view.search.getValue())) {
          //     label = count.toString() + ' ' + i18n.t("Search result for") + ' "' + this.view.search.getValue() + '"';
          // }
          // this.view.search.setLabel(label);
        },

        onExerciseClick: function(model) {
            var panel = this.lazyInit();
            panel.setModel(model);
            this.trigger('panel:stack', panel);
        },

        onExerciseUpdate: function(model) {
            this.collection.set(model, { remove: false });
        },
    });

    return VCustomExercisesManagerContent;

});

